(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.accordion--{{ block.id }}').forEach(function(accordion) {
    accordion.addEventListener('click', function(e) {
      var clickedDetails = e.target.closest('details');
      if (!clickedDetails) return;

      accordion.querySelectorAll('details[open]').forEach(function(openDetails) {
        if (openDetails !== clickedDetails) {
          openDetails.removeAttribute('open');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
